module.exports = __webpack_public_path__ + "img/canals5d-currents@2x.90f00ba0.jpg";